jQuery(function ( $ ) {
	var advantage_list   = $('.advantage_block__list'),
	    advantage_item   = $('.advantage_block__itm'),
	    advantage_length = advantage_item.length,
	    mql          = window.matchMedia('all and (max-width: 1000px)'),
		is_mobile    = mql.matches,
		is_mobile_change = true;

	init();

	function init() {

		if(is_mobile_change === false){

			return false;

		} else {    //срабатывает при переходе из мобильного состояния в десктопное и наоборот

			$('.advantage_more_block .advantage_block__itm').unwrap();
			$('.advantage_more_btn').remove();
			if(!is_mobile) {

				if( advantage_length > 3 ) {
					var elem = $('.advantage_block__itm:nth-child(n+4)');
					elem.wrapAll('<div class="advantage_more_block"></div>');
					advantage_list.after("<div class='advantage_more_btn more' data-active='false'>ещё преимущества</div>");
				}

			} else {

				if( advantage_length > 2 ) {
					var elem = $('.advantage_block__itm:nth-child(n+3)');
					elem.wrapAll('<div class="advantage_more_block"></div>');
					advantage_list.after("<div class='advantage_more_btn more' data-active='false'>ещё преимущества</div>");
				}

			}
			is_mobile_change = false;

		}

	}

	$(document).on('click','.advantage_more_btn',function (  ) {

		if($(this).attr('data-active') === 'false') {
			$('.advantage_more_block').slideDown(300);
			$('.advantage_more_btn').html('скрыть преимущества');
			$('.advantage_more_btn').addClass('active');
			$(this).attr('data-active','true');
		} else{
			$('.advantage_more_block').slideUp(300);
			$('.advantage_more_btn').html('ещё преимущества');
			$('.advantage_more_btn').removeClass('active');
			$(this).attr('data-active','false');
		}

	});

	$(window).resize(function () {
		var mql          = window.matchMedia('all and (max-width: 1000px)'),
			new_is_mobile    = mql.matches;

		if(is_mobile !== new_is_mobile) {
			is_mobile = new_is_mobile;
			is_mobile_change = true;
			init();
		}

	});


});